import {
  Modal as ChakraModal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Stack,
} from '@chakra-ui/react'

import ButtonNavigation from 'components/button-navigation'

import theme from 'theme'

import type { ModalProps } from '@chakra-ui/react'
import type { ButtonNavigationProps } from 'components/button-navigation'
import type { ReactElement } from 'react'

type Props = {
  id: string
  title: string
  message?: string
  size?: ModalProps['size']
  buttons: ButtonNavigationProps[]
  isOpen: boolean
  onClose: () => void
  isLoading?: boolean
  children?: ReactElement
}

const Modal = ({ id, title, message = '', size = 'lg', buttons, isOpen, onClose, isLoading, children }: Props) => {
  return (
    <ChakraModal
      isOpen={isOpen}
      onClose={onClose}
      size={size}
      closeOnOverlayClick={false}
      closeOnEsc={false}
      isCentered
    >
      <ModalOverlay background={theme.colors.alpha.blackalpha['800']} />
      <ModalContent minH="250px">
        <ModalHeader>{title}</ModalHeader>
        <ModalBody>{children ?? message}</ModalBody>
        <ModalFooter>
          <Stack w="100%" direction="row" justify="flex-end" spacing="10px">
            {buttons.map((button, idx) => (
              <ButtonNavigation
                key={`modal${id}Button${idx}`}
                px="4px"
                isDisabled={isLoading}
                {...button}
                onClick={() => {
                  if (isLoading === undefined) onClose()
                  if (button.onClick) button.onClick()
                }}
              />
            ))}
          </Stack>
        </ModalFooter>
      </ModalContent>
    </ChakraModal>
  )
}

export default Modal
